<template>

  <div>
      <div class="content-bottom-padded">
          <el-alert type="info" title="操作说明" show-icon >
              <div> 说明：订单金额20210813后正常统计,之前的数据没有记录。请注意！！使用记录有20分钟延迟 ！！</div>
          </el-alert>
      </div>
    <div>
     <el-row :gutter="24">

      <el-col :span="4">
        <el-input placeholder="卡券名称" v-model="title" size="mini" ><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="6" >
        <el-date-picker size="mini" v-model="create_time" type="daterange" start-placeholder="开始日期"
                        ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd"
                        placeholder="选择日期范围" style="width: 100%;" @change="dateChange" >

        </el-date-picker>
      </el-col>
<el-col :span="4">
         <el-input placeholder="手机号" v-model="mobile" size="mini" ><el-button slot="append" icon="el-icon-search" @click="mobileSearch"></el-button></el-input>
       </el-col>
       <el-col :span="4">
         <el-input placeholder="订单号" v-model="order_id" size="mini" ><el-button slot="append" icon="el-icon-search" @click="orderSearch"></el-button></el-input>
       </el-col>
       <el-col :span="3">
         <el-select size="small" v-model="params.used_status" clearable placeholder="请选择状态" @change="statusSearch">
             <el-option v-for="item in statusOption" :key="item.value" :label="item.title" size="mini" :value="item.value"> </el-option>
         </el-select>
       </el-col>
         <el-col :md="4" :lg="4">
             <el-button size="mini" type="primary" @click="exportData">导出</el-button>
             <el-popover
                     placement="top-start"
                     width="200"
                     trigger="hover"
                     content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
                 <i class="el-icon-question" slot="reference"></i>
             </el-popover>
         </el-col>
    </el-row>
      <br/>
    </div>
    <el-table :data="cardList" style="width: 100%" border height="600" v-loading="loading">
      <el-table-column prop="title" label="优惠券名称" width="200"></el-table-column>
      <el-table-column prop="code" label="优惠券码" width="120"></el-table-column>
      <el-table-column prop="username" label="用户名字" width="150"></el-table-column>
      <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
      <el-table-column prop="used_status" label="操作途径" width="100">
        <template slot-scope="scope">
          <template v-if="scope.row.used_status == 'callback'">
            回退
          </template>
          <template v-else>
            核销
          </template>
        </template>
      </el-table-column>

      <el-table-column prop="used_time" label="记录时间" width="170"></el-table-column>
      <el-table-column prop="used_order" label="核销订单"></el-table-column>
      <el-table-column  label="订单金额(实付)">
          <template slot-scope="scope">
             {{scope.row.fee / 100}}
          </template>
      </el-table-column>
      <!--<el-table-column prop="shop_name" label="核销门店"></el-table-column>-->
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="params.page"
      :page-sizes="[10,20,50]"
      :total="total_count"
      :page-size="params.pageSize">
    </el-pagination>
  </div>
</template>

<script>
import {getCardUserList,exportCardUsed} from '../../../../api/cardticket'

export default {
  props: ['getStatus'],
  data() {
    return {
      mobile:'',
      loading: false,
      total_count: 0,
      cardList: [],
      title:'',
      order_id:'',
      create_time:'',
      statusOption: [
            { title: '核销', value: 'consume' },
            { title: '回退', value: 'callback' }
      ],
      params: {
        card_id: 0,
        title: '',
        begin_date:'',
        end_date:'',
        order_id:'',
        used_status:'',
        is_use: true,
        page: 1,
        pageSize: 20
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.params.page = val
      this.getCardUserList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getCardUserList()
    },
    getCardUserList() {
      this.loading = true
      getCardUserList(this.params).then(res => {
        if (res.data.data.list.length > 0) {
          this.cardList = res.data.data.list
          this.total_count = res.data.data.total_count
          this.loading = false
        } else {
          this.cardList = []
          this.loading = false
        }
      })
        .catch(error => {
          this.loading = false
        })
    },
    mobileSearch(){
       this.params.mobile = this.mobile
         this.params.page = 1
         this.getCardUserList()
    },
     titleSearch()
     {
         this.params.title = this.title
         this.params.page = 1
         this.getCardUserList()
     },
      dateChange (val) {
          if(val) {
              if (val.length > 0) {
                  this.params.begin_date = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                  this.params.end_date = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
              } else {
                  this.params.begin_date = ''
                  this.params.end_date = ''
              }
          }else{
              this.params.begin_date = ''
              this.params.end_date = ''
          }
          this.params.page = 1
          this.getCardUserList()
      },
      orderSearch()
      {
          this.params.order_id = this.order_id
          this.params.page = 1
          this.getCardUserList()
      },
      statusSearch()
      {
          this.params.page = 1
          this.getCardUserList()
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      },
      exportData()
      {
          exportCardUsed(this.params).then(response => {
              if (response.data.status) {
                  this.$message({
                      type: 'success',
                      message: '已加入执行队列，请在设置-导出列表中下载'
                  })
                  return
              } else if (response.data.url) {
                  this.downloadUrl = response.data.url
                  this.downloadName = response.data.filename
                  this.downloadView = true
              } else {
                  this.$message({
                      type: 'error',
                      message: '无内容可导出 或 执行失败，请检查重试'
                  })
                  return
              }
          })
      }

  },
  watch: {
    getStatus(val) {
      if (val) {
        this.getCardUserList()
      }
    }
  },
  mounted() {
    if (this.$route.query.cardId) {
      this.params.card_id = this.$route.query.cardId
    }
    this.getCardUserList()
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// used.vue?363566f6